import { KSpan, KTooltip } from "kahuna-base-react-components"
import React, { SetStateAction, useEffect, useState } from "react"
import { createPortal } from "react-dom"
import { Link } from "react-router-dom"

const AdminNavListElement = ({
  name,
  Icon,
  index,
  selectedIndex,
  setSelectedIndex,
  href,
  flagCount
}: {
  name: string
  Icon: (color?: string) => React.JSX.Element
  index: number
  selectedIndex: number
  setSelectedIndex: React.Dispatch<SetStateAction<number>>
  href: string
  flagCount: number
}) => {
  const onClickEvent = () => {
    setSelectedIndex(index)
  }

  const isSelected = window.location.pathname.endsWith(href)

  const [hover, setHover] = useState<boolean>(false)
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 })

  const chooseIconColor = () => {
    if (flagCount > 0) {
      return "#D92D20"
    }
    if (isSelected) return "#303315"
    else {
      return hover ? "#111" : "#666"
    }
  }
  const chooseBgColor = () => {
    if (isSelected) return "#F2FE67"
    else {
      return hover ? "#F7F7F7" : "#FFF"
    }
  }

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect()
    setTooltipPos({
      top: rect.top + rect.height / 2,
      left: rect.right + 8 // offset tooltip to the right
    })
    setHover(true)
  }

  const handleMouseLeave = () => setHover(false)

  const renderFlagCount = () => {
    const width = flagCount > 9 ? "w-5" : "w-4"
    const className = `${width} h-4 rounded-full bg-[#D92D20] flex items-center justify-center ml-3 mb-6`
    return (
      <div style={{ position: "absolute" }} className={className}>
        <KSpan fontSize={10} text={`${flagCount > 99 ? "99+" : flagCount}`} color="white" />
      </div>
    )
  }

  return (
    <>
      <Link to={`/admin${href}`}>
        <div
          data-testid={`admin-nav-${name.toLowerCase().replace(/\s+/g, "-")}`}
          onClick={onClickEvent}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="w-11 h-11 flex flex-row justify-start items-center group"
          style={{
            backgroundColor: chooseBgColor(),
            padding: "14px",
            transition: "0.4s",
            cursor: "pointer"
          }}
        >
          {flagCount > 0 && renderFlagCount()}
          {Icon(chooseIconColor())}
        </div>
      </Link>

      {hover &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: tooltipPos.top,
              left: tooltipPos.left,
              transform: "translateY(-50%)",
              backgroundColor: "#000",
              color: "#FFF",
              padding: "4px 8px",
              fontSize: 12,
              lineHeight: "16px",
              borderRadius: 4,
              zIndex: 999999,
              pointerEvents: "none",
              whiteSpace: "nowrap"
            }}
          >
            <KSpan text={name} color="#FFF" fontSize={12} lineHeight="16px" />
          </div>,
          document.body
        )}
    </>
  )
}

export default AdminNavListElement
